import { handleDay } from "@/utils/helper";
import { ListVoucher, PaginationType } from "@/utils/interface.global";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import TableRendering from "@/components/table";
import VoucherInfo from "@/components/voucherinfo";
import SearchComponents from "@/components/search";
import { getUserData } from "@/redux/slices/userSlices";
import { useSelector } from "react-redux";
import ToastProvider from "@/hooks/useToastProvider";
import Api from "@/components/api/api";
import { useNavigate } from "react-router-dom";

interface Props {
  setEventID: React.Dispatch<React.SetStateAction<string | null>>
}

const ListVoucherForEvent: React.FC<Props> = ({ setEventID }: Props) => {
  const user = useSelector(getUserData);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [limit] = useState(6);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [eventData, setEventData] = useState("");
  const [data, setData] = useState<any>([]);
  const [eventName, setEventName] = useState<string>("");
  const [pagination, setPagination] = useState<null | PaginationType>(null);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [voucherEventID, setVoucherEventID] = useState<null | string>(
    !searchParams.get("voucherEventID")
      ? null
      : searchParams.get("voucherEventID")
  );
  const eventID = searchParams.get("eventID")

  const fetchDataVoucher = async () => {
    try {
      const reqUrl = "/get-list-voucher";
      const params = {
        key: user.key_login,
        user_id: user.id,
        voucher_code: "",
        start_date: startDate,
        end_date: endDate,
        currentPage: currentPage,
        limit: limit,
        event_id: eventID
      };
      const res = await Api.post(reqUrl, params);
      if (!res.data.status)
        return ToastProvider({ type: "error", content: res.data.message });
      console.log("data", res.data.data)
      setData(res.data.data);
      setEventName(res.data.event_name)
      setPagination(res.data.pagination);
    } catch (error) {
      ToastProvider({
        type: "error",
        content: "Có lỗi xảy ra trong quá trình tải data. Vui lòng thử lại",
      });
    }
  };

  const onChangeEventData = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEventData(event.target.value);
  };
  const handleSearchFunction = () => {
    //eventData, startDate, endDate
    fetchDataVoucher();
  };

  const handleBackButton = () => {
    setEventID(null);
    const activatedTabs = searchParams.get("activatedTabs");
    if (activatedTabs) {
      const options = {
        search: `?activatedTabs=${activatedTabs}`,
      };
      navigate(options, { replace: true });
    }
  };

  const props = {
    setPropsID: setVoucherEventID,
    currentPage,
    nameState: "voucherEventID",
    setCurrentPage,
    pagination,
    dataRendering: data,
    contentHeader: `Sự Kiện: ${eventName}`,
    isVoucherActivatedNumber: true,
    isBack: true,
    handleBackButton: handleBackButton
  };

  useEffect(() => {
    fetchDataVoucher();
    return () => setData([])
  }, [currentPage]);

  return !voucherEventID ? (
    <>
      <SearchComponents
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        placeHolder="Mã Voucher"
        nameInput="Nhập Mã Voucher"
        dataInput={eventData}
        onChangeFunc={onChangeEventData}
        searchFunc={handleSearchFunction}
      />
      <TableRendering {...props} />
    </>
  ) : (
    <VoucherInfo setVoucherID={setVoucherEventID} />
  );
};

export default ListVoucherForEvent;
